import {SortableContainer, SortableElement, SortableHandle} from "react-sortable-hoc";

const component = ({children}: {children: JSX.Element}) => children;

export const SortableItem = SortableElement(component);
export const SortableList = SortableContainer(component);
export const SortHandle = SortableHandle(component);